import { useCallback, useContext } from "react";
import { Action } from "@radarly/core/panel/action";
import { Workspace } from "@radarly/models/workspace";
import ChannelContext from "../../panel/context";

export function useOpenWizardLibrary() {
  const { dispatch } = useContext(ChannelContext);
  return useCallback(
    (workspaceId?: Workspace["id"]) => {
      dispatch(
        Action.panelOpened({
          type: "template-library",
          workspaceId,
        })
      );
    },
    [dispatch]
  );
}
